/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ReportAppMessageActionRequest} from '@cash-web/protos/squareup/cash/messagingplatformcommon/app/AppServiceProto.pb'
import {ReportAppMessageActionResponse} from '@cash-web/protos/squareup/cash/messagingplatformcommon/app/AppServiceProto.pb'


export const reportAppMessageAction = (request:ReportAppMessageActionRequest, options?: CashRequestOptions) => post<ReportAppMessageActionRequest, ReportAppMessageActionResponse>("/cash-app/app-messages/report-app-message-action", request, {...options, rejectOnError: true })